/* __V3D_TEMPLATE__ - template-based file; delete this line to prevent this file from being updated */
/* eslint-disable */

// ? if using vuex
// import store from '../store'

var CONTAINER_ID = 'v3d-container'

function createApp(REL_URL_PREFIX, FILE_PATH, PUZZLES_ENABLED) {
  var LOAD_LOGIC_FILES = PUZZLES_ENABLED
  var params = v3d.AppUtils.getPageParams()

  var logicURL = params.logic
    ? params.logic
    : '__LOGIC__visual_logic.js'.replace('__LOGIC__', REL_URL_PREFIX)
  var sceneURL = params.load ? params.load : FILE_PATH
  if (!sceneURL) {
    console.log('No scene URL specified')
    return
  }

  // some puzzles can benefit from cache
  v3d.Cache.enabled = false

  if (LOAD_LOGIC_FILES) {
    if (v3d.AppUtils.isJS(logicURL)) {
      new v3d.PuzzlesLoader().loadLogic(logicURL, function() {
        var initOptions = v3d.PL
          ? v3d.PL.execInitPuzzles({
              container: CONTAINER_ID
            }).initOptions
          : { useFullscreen: true }
        return loadScene(sceneURL, initOptions)
      })
    } else {
      return loadScene(sceneURL, { useFullscreen: true })
    }
  } else {
    return loadScene(sceneURL, { useFullscreen: true })
  }
}

function loadScene(sceneURL, initOptions) {
  initOptions = initOptions || {}

  var ctxSettings = {}
  if (initOptions.useBkgTransp) ctxSettings.alpha = true
  if (initOptions.preserveDrawBuf) ctxSettings.preserveDrawingBuffer = true

  var preloader = initOptions.useCustomPreloader
    ? createCustomPreloader(
        initOptions.preloaderProgressCb,
        initOptions.preloaderEndCb
      )
    : new v3d.SimplePreloader({ container: CONTAINER_ID })

  if (v3d.PE) {
    puzzlesEditorPreparePreloader(preloader)
  }

  var app = new v3d.App(CONTAINER_ID, ctxSettings, preloader)
  if (initOptions.useBkgTransp) {
    app.clearBkgOnLoad = true
    app.renderer.setClearColor(0x000000, 0)
  }

  // namespace for communicating with code generated by Puzzles
  app.ExternalInterface = {}
  prepareExternalInterface(app)

  if (initOptions.preloaderStartCb) initOptions.preloaderStartCb()

  app.loadScene(
    sceneURL,
    function() {
      app.enableControls()
      app.run()

      if (v3d.PE) v3d.PE.updateAppInstance(app)
      if (v3d.PL) v3d.PL.init(app, initOptions)

      // ? store verge app in Vuex
      // ! needs to store as non reactive object
      // or performance goes down
      // store.commit('SET_VERGE_APP', app)
      runCode(app)
    },
    null,
    function() {
      console.log("Can't load the scene " + sceneURL)
    }
  )
  return app
}

function createCustomPreloader(updateCb, finishCb) {
  function CustomPreloader() {
    v3d.Preloader.call(this)
  }

  CustomPreloader.prototype = Object.assign(
    Object.create(v3d.Preloader.prototype),
    {
      onUpdate: function(percentage) {
        v3d.Preloader.prototype.onUpdate.call(this, percentage)
        if (updateCb) updateCb(percentage)
      },
      onFinish: function() {
        v3d.Preloader.prototype.onFinish.call(this)
        if (finishCb) finishCb()
      }
    }
  )

  return new CustomPreloader()
}

/**
 * Modify the app's preloader to track the loading process in the Puzzles Editor.
 */
function puzzlesEditorPreparePreloader(preloader) {
  // backward compatibility for loading new projects within the old Puzzles Editor
  if (
    v3d.PE.loadingUpdateCb !== undefined &&
    v3d.PE.loadingFinishCb !== undefined
  ) {
    var _onUpdate = preloader.onUpdate.bind(preloader)
    preloader.onUpdate = function(percentage) {
      _onUpdate(percentage)
      v3d.PE.loadingUpdateCb(percentage)
    }

    var _onFinish = preloader.onFinish.bind(preloader)
    preloader.onFinish = function() {
      _onFinish()
      v3d.PE.loadingFinishCb()
    }
  }
}

function prepareExternalInterface(app) {
  // register functions in the app.ExternalInterface to call them from Puzzles, e.g:
  // app.ExternalInterface.myJSFunction = function() {
  //     console.log('Hello, World!');
  // }
}

function runCode(app) {
  // add your code here, e.g. console.log('Hello, World!');
}

export { createApp, CONTAINER_ID }
